import dashboardBanner from '@/assets/login-banner-dashboard.jpg';

export const DEFAULT_BANNER_IMAGE = dashboardBanner;

export interface LoginBanner {
  id: string;
  tag?: string;
  title: string;
  highlight?: string;
  description: string;
  image?: string;
  ctaLabel?: string;
  ctaHref?: string;
}

/** Edite esta lista para adicionar, remover ou alterar banners da tela de login. */
export const LOGIN_BANNERS: LoginBanner[] = [
  {
    id: 'dashboard',
    tag: 'Novidade',
    title: 'Novo Dashboard',
    highlight: 'mais completo',
    description:
      'Acompanhe suas vendas, estoque, financeiro e atendimento em um só lugar, com uma visão ainda mais clara.',
    image: dashboardBanner,
  },
  {
    id: 'crm',
    tag: 'CRM',
    title: 'Atendimento',
    highlight: 'organizado',
    description: 'Conversas, funil de leads, agenda e follow-ups conectados para sua equipe vender mais.',
    image: dashboardBanner,
  },
  {
    id: 'portal',
    tag: 'Portal do Corretor',
    title: 'Parceiros',
    highlight: 'conectados',
    description: 'Compartilhe seu estoque com corretores parceiros e envie materiais direto pelo WhatsApp.',
    image: dashboardBanner,
  },
];
